module.exports = __webpack_public_path__ + "img/tlf_qyltdn_tzjbbanner.0637bf5c.png";